
import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Gallery = () => {
const carouselEvents = {
        autoplay: false,
        loop: true,
        margin: 10,
        nav: true,
        dots: true,
         navText: ["<span className='lnr ti-angle-left'></span>", "<span className='lnr ti-angle-right'></span>"],
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 3
            },

            1024: {
                items: 4
            },

            1366: {
                items: 4
            },

            1650: {
                items: 4
            }
        }
    };
    return (
        <>
            <div className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/contactUs.webp)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 caption text-center">
                            <h1>Events & Conference</h1>
                        </div>
                    </div>
                </div>
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </div>

<section className="section-padding bg-white" data-scroll-index="1">
    <div className='container'>
        <div className='col-md-12'>
            <div className="section-title">Events </div>
            <p>At Residency Group Hotels, we host unforgettable weddings, conferences, and events, tailored to your unique needs and preferences. Our experienced team curates bespoke experiences, ensuring every detail is meticulously planned and executed.</p>
            
            <div className="section-title">We Host </div>
            <ul>
                <li><strong>Weddings</strong>: Fairytale weddings, intimate gatherings, or grand celebrations – we make your special day truly unforgettable.</li>
                <li><strong>Conferences</strong>: Professional conferences, seminars, and workshops – our state-of-the-art facilities and expert team ensure a successful event.</li>
                <li><strong>Events</strong>: Corporate events, parties, and social gatherings – we create memorable experiences that exceed your expectations.</li>
               
            </ul>
            <p>Whether you're planning a wedding, conference, or social gathering, our team is dedicated to making your event a success. Contact us to discuss your ideas and let us create an unforgettable experience for you and your guests.</p>
           
        </div>
    </div>
        <div className="container">
            <div className="section-title">Marriage </div>
            <div className="row">
                <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>
                     <div className='item'>
                        <a href="img/events/Marriage.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-a.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-a.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-1.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-1.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-2.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-2.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-3.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-3.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-4.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-4.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-5.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-5.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-6.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-6.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-7.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-7.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-8.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-8.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-9.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-9.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-10.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-10.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-11.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-11.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-12.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-12.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-13.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-13.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-15.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-15.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-17.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-17.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                   
                     <div className='item'>
                        <a href="img/events/Marriage-20.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-3.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     
                     <div className='item'>
                        <a href="img/events/Marriage-21.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-21.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-22.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-22.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-23.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-23.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-24.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-24.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-25.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-25.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-27.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-27.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-28.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-28.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-29.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-29.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-30.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-30.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-32.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-32.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-33.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-33.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-34.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-34.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-35.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-35.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-36.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-36.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-37.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-37.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-39.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-39.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-40.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-40.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-41.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-41.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-42.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-42.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-43.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-43.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-44.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-44.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-45.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-45.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-47.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-47.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-48.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-48.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-49.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-49.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-50.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-50.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-51.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-51.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-52.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-52.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a> 
                         </div>                       
                     <div className='item'>
                        <a href="img/events/Marriage-53.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Marriage-53.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a> 
                         </div>                       
                    
 
                </OwlCarousel>
            </div>
        </div>
         <div className="container">
            <div className="section-title">Corporate</div>
            <div className="row">
                 <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>                    
                    <div className='item'>
                        <a href="img/events/Corporate-2026-1.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-2026-1.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Corporate-2026-3.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-2026-3.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-2026-2.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-2026-2.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                   
                    <div className='item'>
                        <a href="img/events/Corporate-8.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-8.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-9.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-9.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-10.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-10.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-11.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-11.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                   
                    <div className='item'>
                        <a href="img/events/Corporate-2.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-2.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                   
                    <div className='item'>
                        <a href="img/events/Corporate-4.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-4.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-5.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-5.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-6.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-6.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-7.webp" title="" className="img-zoom">
                            <div className="img-block">
                                <div className="wrapper-img"> 
                                    <img src="img/events/Corporate-7.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>

                </OwlCarousel>
            </div>
        </div>
        
         
    </section>


<section className="section-padding" data-scroll-index="1">
        <div className="container">
            <div className="section-title">Video</div>
             <div className="row">
                                    <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>
                                        {[1, 3, 4, 12].map((num) => (
                                            <div className="item" key={num}>
                                                <video
                                                    width="100%"
                                                    height="auto"
                                                    controls
                                                    preload="metadata"
                                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                                >
                                                    <source src={`videos/video-${num}.mp4`} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        ))}
                                    </OwlCarousel>
                                </div>
        </div>
    </section>

    
 

        </>
    )
};

export default Gallery;
